import React from 'react';
import Icon from '@/components/ui/AppIcon';

const ContactInfo: React.FC = () => {
  const contactDetails = [
    {
      icon: 'EnvelopeIcon',
      title: 'Professional Email',
      content: 'info@diaax.com',
      description: 'For general inquiries and initial conversations',
      href: 'mailto:info@diaax.com',
    },
    {
      icon: 'PhoneIcon',
      title: 'WhatsApp Business',
      content: '+447888397822',
      description: 'Quick responses via WhatsApp for urgent inquiries',
      href: 'https://wa.me/447888397822',
      isWhatsApp: true,
    },
    {
      icon: 'ClockIcon',
      title: 'Response Timeline',
      content: '2-3 Business Days',
      description: 'We review all requests carefully and respond thoughtfully',
    },
    {
      icon: 'MapPinIcon',
      title: 'Official Address',
      content: '128, City Road, London, EC1V 2NX, UNITED KINGDOM',
      description: 'Registered company address',
    },
  ];

  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-text-primary mb-3 sm:mb-4">
          Alternative Contact Methods
        </h2>
        <p className="text-sm sm:text-base text-text-secondary leading-relaxed">
          We understand that different institutions have varying communication preferences and security requirements. Choose the method that works best for your organization.
        </p>
      </div>

      <div className="space-y-4 sm:space-y-6">
        {contactDetails.map((detail, index) => (
          <div
            key={index}
            className={`bg-white rounded-lg institutional-shadow p-4 sm:p-6 transition-all duration-300 ${
              detail.isWhatsApp
                ? 'hover:shadow-2xl hover:scale-105 hover:border-2 hover:border-teal-500'
                : 'hover:shadow-xl transition-institutional'
            }`}
          >
            <div className="flex items-start gap-3 sm:gap-4">
              <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
                detail.isWhatsApp
                  ? 'bg-green-500 animate-pulse' : 'bg-institutional/10'
              }`}>
                <Icon name={detail.icon as any} size={20} className={detail.isWhatsApp ? 'text-white' : 'text-institutional'} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base sm:text-lg font-semibold text-text-primary mb-1 sm:mb-2">
                  {detail.title}
                </h3>
                {detail.href ? (
                  <a
                    href={detail.href}
                    target={detail.isWhatsApp ? '_blank' : undefined}
                    rel={detail.isWhatsApp ? 'noopener noreferrer' : undefined}
                    className={`font-medium mb-1 inline-block break-all sm:break-normal ${
                      detail.isWhatsApp
                        ? 'text-green-600 hover:text-green-700 text-base sm:text-xl' : 'text-institutional hover:underline text-sm sm:text-base'
                    }`}
                  >
                    {detail.isWhatsApp && <span className="mr-2">💬</span>}
                    {detail.content}
                  </a>
                ) : (
                  <p className="text-institutional font-medium mb-1 text-sm sm:text-base break-words">{detail.content}</p>
                )}
                <p className="text-xs sm:text-sm text-text-secondary">{detail.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;